import PodRoomControlButtons from '@/components/Pages/Connections/ConnectionApp/components/PodRoomControlButtons.vue'

export default {
  components : {
    PodRoomControlButtons
  },

  methods : {
    checkPodRoomRoleBehaviour(roomData){
      let requestBehaviour = 'leave';

      switch(roomData.role){
        case 'owner':
          requestBehaviour = 'broke';
        break;
      }

      return requestBehaviour;
    },

    handleClickPodRoomControlButton(roomData){
      this.$store.dispatch({
        type            : 'connectionLeaveModal/updateModal',
        isOpen          : true,
        isFreezModal    : false,
        isSubmitLoading : false,
        behaviour       : this.checkPodRoomRoleBehaviour(roomData),
        podRoom         : roomData,
      });
    }
  }
}